import { useMemo } from 'react';
import { useFormik } from 'formik';

import { CHILD_BEHAVIOR_ISSUES_SCHEMA, ChildBehaviorIssuesField } from '../../../../../common';

import type { ChildBehaviorIssuesFormValues } from '../../../../../common';
import type { ChildBehaviorIssuesSectionProps } from './types';

export default function ChildBehaviorIssuesSection({
  childBehaviorIssues,
  disabled,
  onSave,
}: ChildBehaviorIssuesSectionProps) {
  const initialValues = useMemo<ChildBehaviorIssuesFormValues>(
    () => ({ child_behavior_issues: childBehaviorIssues }),
    [childBehaviorIssues],
  );
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: CHILD_BEHAVIOR_ISSUES_SCHEMA,
    onSubmit: () => undefined,
  });
  const handleBlur = async () => {
    const value = formik.values.child_behavior_issues.trim();
    if (!CHILD_BEHAVIOR_ISSUES_SCHEMA.isValidSync(formik.values) || value === childBehaviorIssues) {
      return;
    }
    if (!(await onSave(value))) {
      formik.setFieldError('child_behavior_issues', 'Unable to save. Please try again.');
    }
  };

  return <ChildBehaviorIssuesField disabled={disabled} formik={formik} onBlur={handleBlur} />;
}
